/**
 * Map a waypoint's position in the interleaved waypoints array to the stop-segment index it
 * belongs to, given which waypoint indices are stops.
 *
 * A fixed route's `waypoints` array mixes stops (locked control points) with intermediate
 * (draggable) control points, so a waypoint's *array index* is NOT the same as the index of the
 * stop-segment it sits in. A dragged/inserted vertex belongs to the segment that follows the last
 * stop at-or-before it, i.e. `(number of stop-waypoints at index <= waypointIndex) - 1`.
 *
 * Before this was extracted, the waypoint-drag handlers passed the raw waypoint index downstream
 * as the segment index, which caused `recalculateSegmentMetrics` to refresh the WRONG segment's
 * travel time/distance whenever a route had intermediate waypoints.
 *
 * @param stopWaypointIndices indices (into the waypoints array) that correspond to stops
 * @param waypointIndex the array index of the dragged/inserted waypoint
 * @returns the stop-segment index (clamped to >= 0)
 */
export function segmentIndexForWaypoint(stopWaypointIndices: Set<number>, waypointIndex: number): number {
  let segmentIndex = -1;
  stopWaypointIndices.forEach((idx) => {
    if (idx <= waypointIndex) segmentIndex += 1;
  });
  return Math.max(0, segmentIndex);
}
